export const LANDING = '/';
export const ADMIN = '/admin';
export const STUDENT = '/student';
